import * as MessageActions from '../../common/messageBox/actions/actions';
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {downloadFile, validateFinalTwc} from '../utils';
import {getUrl} from '../constants';

export const fetchTwcList = (dealer, status, url) => (dispatch) => {
  let isInvalidData = false;
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/query?type=M&dealer=${dealer}${url}&status=${status}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_LIST,
        [
          (response) => {
            isInvalidData = validateFinalTwc(response.data);
            return {
              'type': ActionTypes.FETCHED_TWC_LIST,
            };
          },
          () => {
            if (isInvalidData) {
              return MessageActions.addMessageBoxInfo(
                'Hay garantías en estado enviado, por favor actualizar.'
              );
            }
            return MessageActions.dismissMessageBox();
          },
        ],
        [
          ActionTypes.FETCHED_TWC_LIST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchFileData = (params) => (dispatch) => {
  const data = {
    'account': params.account,
    'numTwc': params.numTwc,
    'detail': params.detail,
  };
  return dispatch(
    apiActionCreator({
      'endpoint': '/warranties/warrantyFile',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_FILE_DATA,
        [
          (response) => {
            const url = getUrl(params);
            downloadFile(response.data);
            dispatch(fetchTwcList(params.dealer, params.status, url));
            return {
              'type': ActionTypes.FETCHED_FILE_DATA,
            };
          },
          () => MessageActions.addMessageBoxInfo('Garantías encontradas.'),
        ],
        [
          ActionTypes.FETCHED_FILE_DATA_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const fetchWarrantySequences = () =>
  apiActionCreator({
    'endpoint': '/warranties/sequence',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_WARRANTY_SEQUENCES,
      ActionTypes.FETCHED_WARRANTY_SEQUENCES,
      [
        ActionTypes.FETCHED_WARRANTY_SEQUENCES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchWarrantyStatus = () =>
  apiActionCreator({
    'endpoint': '/warranties/status',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_WARRANTY_STATUS,
      ActionTypes.FETCHED_WARRANTY_STATUS,
      [
        ActionTypes.FETCHED_WARRANTY_STATUS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const addWarrantyChecked = (warrantyCode) => ({
  'type': ActionTypes.ADD_WARRANTY_CHECKED,
  'payload': warrantyCode,
});

export const removeWarrantyChecked = (warrantyCode) => ({
  'type': ActionTypes.REMOVE_WARRANTY_CHECKED,
  'payload': warrantyCode,
});

export const addAllWarrantyChecked = (rows) => ({
  'type': ActionTypes.ADD_ALL_WARRANTY_CHECKED,
  'payload': rows,
});

export const removeAllWarrantyChecked = (rows) => ({
  'type': ActionTypes.REMOVE_ALL_WARRANTY_CHECKED,
  'payload': rows,
});

export const updateWarrantyStatus = (params = {}) => (dispatch) => {
  const data = {
    'status': params.status,
    'detail': params.detail,
  };

  return dispatch(
    apiActionCreator({
      'endpoint': '/warranties/update',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_TWC_LIST,
        [
          () => {
            const url = getUrl(params);
            dispatch(fetchTwcList(params.dealer, params.currentStatus, url));
            return {
              'type': ActionTypes.UPDATED_TWC_LIST,
            };
          },
          () => MessageActions.addMessageBoxInfo('Garantías actualizadas.'),
        ],
        [
          ActionTypes.UPDATED_TWC_LIST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const clearTwcList = () => ({
  'type': ActionTypes.CLEAR_TWC_LIST,
});
